import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { therapistsApi } from '@/api/endpoints';
import { SPECIALTIES } from '@/lib/specialties';
import { toSlug } from '@/lib/seo';
import { PublicHeader } from '@/components/public/public-header';
import { PublicFooter } from '@/components/public/public-footer';

export const Route = createFileRoute('/especialidades/')({ component: EspecialidadesIndexPage });

function EspecialidadesIndexPage() {
  const { data = [] } = useQuery({
    queryKey: ['therapists', { all: true }],
    queryFn: () => therapistsApi.list({}),
  });

  const counts = SPECIALTIES.map((spec) => ({
    spec,
    slug: toSlug(spec),
    count: data.filter((t: any) => (t.specialties ?? []).includes(spec)).length,
  })).filter((c) => c.count > 0);

  return (
    <div className="bg-[#FBF8F3] min-h-screen flex flex-col">
      <PublicHeader />
      <main className="flex-1">
        <div className="max-w-5xl mx-auto px-4 py-12">
          <div className="mb-10">
            <div className="inline-flex items-center gap-2 bg-coral-50 border border-coral-100 rounded-full px-4 py-1.5 text-coral-600 text-sm font-medium mb-4">
              {counts.length} áreas de atuação
            </div>
            <h1 className="text-4xl font-extrabold text-slate-800">Especialidades</h1>
            <p className="text-slate-500 mt-2">
              Encontre profissionais especializados na área que você precisa.
            </p>
          </div>

          {counts.length === 0 ? (
            <div className="bg-white rounded-2xl border border-slate-100 p-12 text-center">
              <p className="text-slate-500">
                Ainda não temos profissionais cadastrados. Volte em breve!
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
              {counts.map(({ spec, count, slug }) => (
                <Link
                  key={slug}
                  to="/especialidades/$slug"
                  params={{ slug }}
                  className="group flex flex-col justify-between bg-white border border-slate-200 rounded-xl p-4 hover:border-teal-400 hover:shadow-sm transition"
                >
                  <span className="font-semibold text-slate-800 text-sm group-hover:text-teal-700 transition leading-snug">
                    {spec}
                  </span>
                  <span className="text-xs text-slate-400 mt-3">
                    {count} profissional{count !== 1 ? 'is' : ''}
                  </span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
